import { messages } from './calibration-settings-field.messages';
import { CalibrationSettingKey, ICalibrationSettingGroup } from './calibration-settings-field.types';

// Rendered in order as the sections of the calibration settings form. Each
// `name` also needs a matching rule in the update-company Yup schema.
const SETTING_GROUPS = [
  {
    key: 'assignmentSize',
    title: messages.titleAssignmentSize,
    description: messages.descAssignmentSize,
    fields: [
      {
        name: 'maxCalibrationSkillsPerAssignment',
        label: messages.lblMaxSkillsPerAssignment,
        hint: messages.helpMaxSkillsPerAssignment,
      },
      {
        name: 'minCalibrationSkillsPerAssignment',
        label: messages.lblMinSkillsPerAssignment,
        hint: messages.helpMinSkillsPerAssignment,
      },
      {
        name: 'maxCalibrationSkillsPerVideoPerAssignment',
        label: messages.lblMaxSkillsPerVideoPerAssignment,
        hint: messages.helpMaxSkillsPerVideoPerAssignment,
      },
    ],
  },
  {
    key: 'deliveryTiming',
    title: messages.titleDeliveryTiming,
    description: messages.descDeliveryTiming,
    fields: [
      {
        name: 'deliveryWindowHours',
        label: messages.lblDeliveryWindowHours,
        hint: messages.helpDeliveryWindowHours,
      },
      {
        name: 'assignmentCooldownHours',
        label: messages.lblAssignmentCooldownHours,
        hint: messages.helpAssignmentCooldownHours,
      },
      {
        name: 'assignmentDueDays',
        label: messages.lblAssignmentDueDays,
        hint: messages.helpAssignmentDueDays,
      },
    ],
  },
  {
    key: 'evaluatorWorkload',
    title: messages.titleEvaluatorWorkload,
    description: messages.descEvaluatorWorkload,
    fields: [
      {
        name: 'periodLengthDays',
        label: messages.lblPeriodLengthDays,
        hint: messages.helpPeriodLengthDays,
      },
      {
        name: 'maxCalibrationSkillsPerPeriod',
        label: messages.lblMaxSkillsPerPeriod,
        hint: messages.helpMaxSkillsPerPeriod,
      },
    ],
  },
] satisfies readonly ICalibrationSettingGroup[];

// Consumers get the plain interface type; the `satisfies` above is what keeps
// the literal `name`s that the completeness check below reads.
export const CALIBRATION_SETTING_GROUPS: ICalibrationSettingGroup[] = SETTING_GROUPS;

type ConfiguredKey = (typeof SETTING_GROUPS)[number]['fields'][number]['name'];

// A calibration setting added to the form values but not configured above stops
// the build here. No runtime test can catch it: the DOM is built from this array.
export const ALL_CALIBRATION_SETTINGS_CONFIGURED: Exclude<CalibrationSettingKey, ConfiguredKey> extends never ? true : never = true;
